import createPersistedState from 'vuex-persistedstate'

const plugins = [
  createPersistedState({
    key: process.env.VUE_APP_BASE_API_PATH,
    reducer: state => ({
      race: {
        columns: state.race.columns.map(el => ({
          filtersForServer: el.filtersForServer,
          filtersForUI: el.filtersForUI,
          id: el.id,
        })),
        isShowComparesFooter: state.race.isShowComparesFooter,
        savedRaces: state.race.savedRaces,
      },
      races: {
        showStats: state.races.showStats,
      },
    }),
    arrayMerger: (store, saved) => store.map(column => {
      const savedFilters = saved.find(({ id }) => id === column.id) || {}
      return {
        ...column,
        ...savedFilters,
      }
    })
  })
]

const devPlugins = [...plugins]

export default process.env.NODE_ENV !== 'production'
  ? plugins
  : devPlugins
